module.exports = __webpack_public_path__ + "images/macbook-ru@2x-691072.png";